import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SMSApprove } from './SMSApprove';
import { OrderDetail } from './OrderDetail';
import { CreditCard } from './CreditCard';
import {
    getExpensesByMemberNo,
    selectMemberExpenseByMemberNo
} from "../../../state/ducks/member/index";
import { createPayment, selectPayment, selectCurrentPage, changeCurrentPage, getActiveMemberNumber, getPaymentSum, selectPaymentSum, getActiveMemberNoList } from "../../../state/ducks/payment/index"
import $ from 'jquery';
import Modal from '../Modal';
import { createPaymentPages } from '../../../state/ducks/payment/types';

const pageStatus = [createPaymentPages.orderDetail, createPaymentPages.creditCard, createPaymentPages.sms, createPaymentPages.done];

export class CreatePaymentOrder extends Component {

    state = {
        page: createPaymentPages.orderDetail,
        payment: {
            orderdetail: {
                memberNo: "0",
                startDate: new Date(),
                aylikTutar: "",
                aylikTutarOndalik: 0,
                installmentCount: ""
            },
            creditcard: {
                cardHolderName: "",
                cardNumber: "",
                expirationMonth: new Date().getMonth() + 1,
                expirationYear: new Date().getFullYear(),
                cvv: ""
            },
            sms: {
                sms: "",
                gsm: ""
            }

        }
    };
    componentDidMount() {
        this.props.changeCurrentPage(createPaymentPages.orderDetail)
        this.props.getMemberNumber();
        this.props.getActiveMemberNo();
        $("#aciklama").modal('show');
    }

    componentWillReceiveProps(nextProps) {
        var pageName = nextProps.payment.page;
        if (pageName != null && pageName != "") {
            this.setState({ page: pageName });
        }
    }
    changePage = (pageName, clearSmsCode) => {
        var currPage = this.state.page;
        var currPageIndex = pageStatus.findIndex((e) => e === currPage);
        var pageIndex = pageStatus.findIndex((e) => e === pageName);
        if (currPage == "sms" && pageIndex < currPageIndex) {
            if (window.confirm("Devam etmeniz halinde işlem iptal edilecektir ve bilgileri yeniden girmeniz gerekecektir.")) {
                this.props.changeCurrentPage(pageName);
            }
            return;
        }

        if (pageName == "sms" || pageName == "done") {
            this.createPayment(currPage, pageName, clearSmsCode);
        }
        else {
            this.props.changeCurrentPage(pageName);
        }

    }
    getExpensesByMemberNo = (memberNo) => {

        this.props.getMemberExpense(memberNo);
    }
    getPaymentSum = (memberNo) => {
        this.props.getPaymentSummary(memberNo)
    }
    createPayment = (currPage, pageName, clearSmsCode) => {
        var data = this.state.payment;
        if (data.orderdetail.startDate instanceof Date) {
            data.orderdetail.startDate = data.orderdetail.startDate.toLocaleDateString("tr-TR");
        }
        if (clearSmsCode) {
            data.sms = {
                sms: "",
                gsm: ""
            };
        }
        this.props.createPaymentOrder(data, currPage, pageName);
    }
    sendSmsAgain = () => {
        this.createPayment(createPaymentPages.sms, createPaymentPages.sms, true);
    }

    render() {
        var page = this.state.page;

        const { alert, payment } = this.props;
        if (page == "done") {
            return (
                <div className="container-fluid">
                    {/* yesil Alan*/}
                    <div className="row" style={{ padding: "3%" }}>
                        <div className="col-12">
                            {/* KUTU 1 */}
                            <div className="row no-gutters t-kutu t-yesilCizgi">
                                <div
                                    className="col bosluk backtop"
                                    style={{
                                        backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                                    }}
                                >
                                    {/* içerikler */}
                                    <div className="row no-gutters pb-4">
                                        <div className="col-12 d-flex justify-content-center pb-2">
                                            <i className="t-icon-bubble1 t-icGenelBaslikIconYesil" />
                                        </div>
                                        <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslikYesil">
                                            TALEBİNİZ ALINMIŞTIR
                                        </div>
                                        <div className="col-12 text-center t-icYazilar20pt">
                                            Talimatınızı talimatlarım menüsünden takip edebilirsiniz.


                                        </div>
                                    </div>
                                    {/* içerikler BİTTİ */}
                                </div>
                                <div className="col-auto renk" />
                            </div>
                            {/* KUTU 1 BİTTİ */}
                        </div>
                    </div>
                    {/* Duyurlar Baslık*/}
                    {/* duyrular Bitti*/}
                    <div className="row" style={{ height: 30 }} />
                </div>

            )
        }
        else {
            return (
                <div className="contanier-fluid">
                    <Modal message={alert?.message} type={alert?.type} />

                    {page == createPaymentPages.orderDetail ? (
                        <OrderDetail

                            changePage={this.changePage}
                            orderdetail={this.state.payment.orderdetail}
                            getExpense={this.getExpensesByMemberNo}
                            expenses={this.props.expenses}
                            getPaymentSummmary={this.getPaymentSum}
                            payment={this.props.payment}>
                        </OrderDetail>)
                        : page == createPaymentPages.creditCard ? (
                            <CreditCard

                                changePage={this.changePage}
                                creditcard={this.state.payment.creditcard}>
                            </CreditCard>)
                            : page == createPaymentPages.sms ? (
                                <SMSApprove

                                    changePage={this.changePage}
                                    sms={this.state.payment.sms}
                                    sendAgain={() => this.sendSmsAgain()}>
                                </SMSApprove>) : (<div></div>)
                    }


                    <div className="modal" id="aciklama" tabIndex="-1" style={{backgroundColor: "rgba(0,0,0,0.5)"}}>
                        <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
                            {/* Bu kısım animasyon için Hareket eden kısım. */}
                            <div className="t-modalContentMailOrder" id="id-modalTipi" style={(window.innerWidth<=900)?{width:"89%"}: {width:"51%"}}>
                                <div
                                    className="t-modalMailOrder"
                                    id="id-modalGenel"
                                    style={{ backgroundColor: "rgb(255, 255, 255)" ,boxShadow:"3px 3px 3px #939191"}}
                                >
                                    <div className="container-fluid">
                                        {/* Header */}
                                        <div className="row t-modalHeaderMailOrder">
                                            <div
                                                className="col"
                                                id="id-modalHeader"
                                                style={{ color: "rgb(119, 119, 119)" }}
                                            >
                                                TALİMAT GÖNDERİMİ İLE İLGİLİ AÇIKLAMA
                                            </div>
                                            <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                                <i
                                                    className="t-icon-cross"
                                                    id="id-modalHeaderIcon"
                                                    style={{ color: "rgb(119, 119, 119)" }}
                                                />
                                            </div>
                                        </div>
                                        {/* Body */}
                                        <div className="row t-modalBodyMailOrder">
                                            <div
                                                className="col-12 "
                                                id="id-modalBody"
                                                style={{ color: "rgb(119, 119, 119)",fontSize:"12pt" }}
                                            >
                                                <strong>
                                                Kredi kartıyla talimatlar yalnızca “organizasyon ve peşinat ücreti” tutarı toplamı kadar girilebilir.
                                                </strong>
                                                <br />
                                                <strong>
                                                Girdiğiniz ödeme talimatının gerçekleşebilmesi için;
                                                </strong>
                                                <br />
                                                talimat tarihinde, kaydı girilmiş olan kredi kartında yeterli limit
                                                olması durumunda başarılı gerçekleşecektir.
                        
                                                <br />
                                                Tahsilatın başarılı gerçekleşmesi sonrası taksitlere yansıması 1-2
                                                iş günü sürebilmektedir.
                                            </div>
                                        </div>
                                        {/* footer*/}
                                        <div className="row t-modalFooterMailOrder">
                                            <div
                                                className="col-12"
                                                id="id-modalFooter"
                                                style={{ color: "rgb(102, 102, 102)" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        payment: selectPayment(state),
        expenses: selectMemberExpenseByMemberNo(state),
        paymentSumData: selectPaymentSum(state)
    };
}
const mapDispatchToProps = dispatch => ({
    createPaymentOrder: (orderdetail, creditCard, sms) => dispatch(createPayment(orderdetail, creditCard, sms)),
    getMemberNumber: () => dispatch(getActiveMemberNumber()),
    getActiveMemberNo: () => dispatch(getActiveMemberNoList()),
    changeCurrentPage: (page) => dispatch(changeCurrentPage(page)),
    getMemberExpense: (memberNo) => dispatch(getExpensesByMemberNo(memberNo)),
    getPaymentSummary: (memberNo) => dispatch(getPaymentSum(memberNo))
});
export default connect(mapStateToProps, mapDispatchToProps)(CreatePaymentOrder);